import React from 'react'
import {MailAddrForm} from './mailaddrform.react.js'
import {MsgBox} from './msgbox.react.js'

const ChangeMailaddrForm = React.createClass({
  getInitialState() {
    return {
      showMsgBox: false,
    };
  },

  close: function(e) {
    this.setState({showMsgBox:false})
  },

  onChangeMailaddr(e, mailaddr) {
    this.props.close(e)

    const vals = {
      mailaddr,
    };

    // post login
    $.ajax({
      url: '/submit_change_mailaddr',
      type: 'POST',
      data:vals
    }).done((data) => {
      if (data.result) {
        this.setState({showMsgBox:true})
      }
      else {
        alert("正しいメールアドレスを入力してください")
      }
    })
  },

  render: function() {
    return (
      <div>
        <MsgBox showModal={this.state.showMsgBox} close={this.close} caption='メールアドレスの変更'
          msg={`確認用のメールを送信しました。
メールを確認して、リンクをクリックしてください。`}/>

        <MailAddrForm caption="メールアドレスを変更" okbutton="メールアドレスを変更する" showModal={this.props.showModal}
          close={this.props.close} onsubmit={this.onChangeMailaddr}/>
      </div>
    )
  }
})

const ChangePasswordForm = React.createClass({
  getInitialState() {
    return {
      showMsgBox: false,
    };
  },

  close: function(e) {
    this.setState({showMsgBox:false})
  },

  onChangePassword(e) {
    if (e) {
      this.props.close(e)
    }

    $.ajax({
      url: '/submit_reset_password',
      type: 'POST',
      data:{}
    }).done((data) => {
      console.log(data)
      if (data.result) {
        this.setState({showMsgBox:true})
      }
      else {
        alert("メールを送信できませんでした")
      }
    })
  },

  render: function() {
    return (
      <div>
        <MsgBox showModal={this.state.showMsgBox} close={this.close} caption='メールアドレスの変更'
          msg={`確認用のメールを送信しました。
メールを確認して、リンクをクリックしてください。`}/>

        <MsgBox caption="パスワード変更" okbutton="パスワードを変更する"
         msg="パスワードを変更しますか" showModal={this.props.showModal}
         hasCancel={true} close={this.props.close} onok={this.onChangePassword}/>
      </div>
    )
  }
})



export const UserMenu = React.createClass({
  getInitialState() {
    return {
      showChangeMailaddr: false,
      showChangePassword: false,
    };
  },

  close(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ showChangeMailaddr: false, showChangePassword: false});
  },

  openChangeMailaddr(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ showChangeMailaddr: true });
  },

  openChangePassword(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ showChangePassword: true });
  },

  render: function() {
    return (
      <div>
        <ChangeMailaddrForm showModal={this.state.showChangeMailaddr} close={this.close}/>
        <ChangePasswordForm showModal={this.state.showChangePassword} close={this.close}/>
        <ul className="nav navbar-nav navbar-right">
          <li className="dropdown">
            <a href="http://ikebukuro.sinsi.jp/#" className="dropdown-toggle" data-toggle="dropdown">
              {show_user}<span className="caret"></span></a>
            <ul className="dropdown-menu" role="menu">
              <li><a id="link-mailaddr" href="#" onClick={this.openChangeMailaddr}>メールアドレス変更</a></li>
              <li><a id="link-changepassword" href="#" onClick={this.openChangePassword}>パスワード変更</a></li>
              <li><a id="link-logout" href="/logout">ログアウト</a></li>
            </ul>
          </li>
        </ul>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./components/usermenu.react.js